import { render, staticRenderFns } from "./DealDetai.vue?vue&type=template&id=7f5ff5d6&"
import script from "./DealDetai.vue?vue&type=script&lang=js&"
export * from "./DealDetai.vue?vue&type=script&lang=js&"
import style0 from "./DealDetai.vue?vue&type=style&index=0&id=7f5ff5d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports